<template>
  <div class="page document-audit">
    <div class="content-box">
       <div class="content-left" v-if="documentInfo.type=='1' || documentInfo.type=='3'">
          <div class="content-title" >
            文档版本: {{documentInfo.versionName}}（中文）
          </div>
          <el-scrollbar ref="view-box" style="position: relative;flex: 1;height:100%;">
            <router-link v-if="auditHistory.id" class="contrast-msg" tag="div" :to="{path:'/document/contrast',query:{id:$route.query.id,docMenuId:$route.query.docMenuId,type:1}}" >
              <el-button class="w150 " type="primary" to="">
              查看历史版本对比
              </el-button>
            </router-link>
            <div class="view-box">
              <div class="html" v-html="documentInfo.content"></div>
            </div>
          </el-scrollbar>
       </div>
       <div class="content-right" v-if="documentInfo.type=='2' || documentInfo.type=='3'">
          <div class="content-title">
            文档版本: {{documentInfo.versionName}}（英文）
          </div>
          <el-scrollbar ref="view-box" style="position: relative;flex: 1;height:100%;">
            <router-link v-if="auditHistory.id" class="contrast-msg" tag="div" :to="{path:'/document/contrast',query:{id:$route.query.id,docMenuId:$route.query.docMenuId,type:2}}" >
              <el-button class="w150 " type="primary" to="">
              查看历史版本对比
              </el-button>
            </router-link>
            <div class="view-box">
              <div class="html" v-html="documentInfo.englishContent"></div>
            </div>
          </el-scrollbar>
       </div>
    </div>
    <div class="content-box">
       <div class="content-left">
          <div class="content-title">
            修订说明
          </div>
          <el-scrollbar style="position: relative;flex: 1;height:100%;">
            <div class="remark-scroll">
              <ul class="remark-list">
                <li class="remark-item" v-for="item in documentInfo.docHistoryList" :key="item.createTime">
                  <div class="list-title"><b class="b">版本 {{item.versionName}}</b> <span class="date">{{item.createTime | parseTime()}}</span></div>
                  <div class="list-content">
                    {{item.remark}}
                  </div>  
                  <div v-if="item.tag == 2" class="list-record"><b class="b">{{item.adminName}}</b>自动保存成功</div>
                  <div v-else class="list-record"><b class="b">{{item.adminName}}</b>编辑了文档、添加了修订备注</div>
                </li>
              </ul>
            </div>
          </el-scrollbar>
       </div>
       <div class="content-right">
          <div class="content-title">
            审核
          </div>
          <div class="content-item">
            <div class="audit-box">
              <el-form class="form-box" :model="formData" ref="formRef"  hide-required-asterisk>
                <el-form-item class="margin-b10"  prop="reviewState"  :rules="[  { required: true, message: '不能为空'},  ]">
                  <span class="form-lable">审核结果</span>
                  <span class="audit-type">
                    <el-radio class="radio margin-r50" v-model="formData.reviewState" label="3">通过</el-radio>
                    <el-radio class="radio" v-model="formData.reviewState" label="4">驳回</el-radio>
                  </span>
                </el-form-item>
                <div v-if="formData.reviewState==3">
                  <span class="form-lable">发布设置</span>
                  <el-form-item class="margin-b10" label="发布类型" prop="publishState" :rules="[  { required: true, message: '不能为空'},  ]">
                    <el-radio v-model="formData.publishState" label="3">立即发布</el-radio>
                    <el-radio v-model="formData.publishState" label="2">定时发布</el-radio>
                    <el-radio v-model="formData.publishState" label="1">暂不发布</el-radio>
                  </el-form-item>
                  <div class="form-msg" v-if="formData.publishState==3">选择立即发布后，文档将会立即发布</div>
                  <div class="date-box" v-if="formData.publishState==2">
                    <el-form-item label="发布时间" prop="publishTime" :rules="[  { required: true, message: '不能为空'},  ]">
                      <el-date-picker
                        v-model="formData.publishTime"
                        type="datetime"
                        placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </div>
                  <div class="form-msg" v-if="formData.publishState==1">选择暂不发布后，可稍后在文档列表中发布</div>
                </div>
                <div v-if="formData.reviewState==4">
                  <span class="form-lable">审核意见</span>
                  <el-form-item label="" prop="reviewComments" :rules="[  { required: true, message: '不能为空'},  ]">
                      <el-input
                        :rows="6"
                        show-word-limit
                        type="textarea"
                        v-model="formData.reviewComments" 
                        placeholder="请输入">
                      </el-input>
                  </el-form-item>
                </div>
                <div class="text-center">
                    <el-button class="w150" type="primary" @click="onAudit()">完成审核</el-button>
                </div>
              </el-form>
            </div>
          </div>
       </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index.js';
import Tinymce from '@/components/Tinymce';
import { util } from 'echarts';

export default {
  components: {Tinymce},
  watch: {
    'formData.reviewState' (oldVal,newVal) {
      if(newVal == 4){
        this.formData.publishState = '3';
      }
      if(newVal == 3){
        this.formData.publishState = '1';
      }
    },
  },
  data() {
    return {
      formData:{
        reviewState:'3',
        publishState:'3',
        publishTime:'',
        reviewComments:'',
      },
      documentInfo:'',
      versionComparefDocument:'',
      tab_label:'audit',
      auditHistory:{},
    }
  },
  mounted(){
    this.queryDocumentInfo();
    this.queryHistoryDoc();
  },
  methods:{
    //获取详情
    queryDocumentInfo(){
      this.$apis.documentServer.queryDocumentInfo({
        id: this.$route.query.id,//	string	
      })
      .then((res) => {
        if (res.code == 0) {
          this.documentInfo = res.data;
          this.documentInfo.type = this.documentInfo.type?this.documentInfo.type:'1';
          store.commit("breadcrumbStore/setMenuBreadcrumb", {'menu': 'audit', name: `${res.data.docMenuTitle} / 审核文档`, path: ''} );
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取记录详情
    queryHistoryDoc(){
      this.$apis.documentServer.queryHistoryDoc({
        docMenuId:this.$route.query.docMenuId,//	string	docMenuId
        id:this.$route.query.id,//	string	id
      })
      .then((res) => {
        if (res.code == 0) {
          this.auditHistory = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSelectHistory(value,item=''){
      this.tab_label = value;
      if(item){
        this.versionComparef()
      }
    },
    versionComparef(){
      this.$apis.documentServer.versionComparefDocument({
        docMenuId:this.$route.query.docMenuId,//	string	docMenuId
        id:this.$route.query.id,//	string	id
      })
      .then((res) => {
        if (res.code == 0) {
          this.versionComparefDocument = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onAudit() {
      this.$refs['formRef'].validate(valid => {
          if (valid) {
            this.$dialogs.confirm({
              content: '确定提交审核结果？',
            }).then(() => {
              this.$apis.documentServer.auditDocument({
                docMenuId:this.$route.query.docMenuId,//	必选	int	分类id
                id:this.$route.query.id,//	必选	string	ID
                reviewState:this.formData.reviewState,//	必选	int	审核状态3通过4不通过
                publishState:this.formData.publishState,//	必选	int	发布状态1暂不发布2定时发布3立即发布
                publishTime:this.formData.publishTime?this.formData.publishTime.getTime():'',//	可选	int	定时发布时间
                reviewComments:this.formData.reviewComments,//	可选	string	审核意见
              }).then((res) => {
                if (res.code == 0) {
                  this.$message.success('审核成功');
                  this.$router.replace({
                    path: "/document/list",
                    query:{
                      docMenuId:this.$route.query.docMenuId,
                      date:new Date().getTime()
                    }
                  });
                } else {
                  this.$message.error(res.message);
                }
              });
            })
            .catch((val) => {});
          }
      })
    },
  }
}
</script>

<style  lang="scss">
  .document-audit{
    margin-top: 20px;
    padding: 26px 23px;
    border-radius: 5px;
    background-color: #fff;
    .content-box{
      display: flex;
      margin-bottom: 20px;
      .content-title{
        padding-left: 17px;
        line-height: 43px;
        background: #28262C;
        font-size: 16px;
        font-weight: bold;
        color: #E7DCAE;
      }
      .contrast-msg{
        position: absolute;
        top: 10px;
        right: 20px;
        cursor: pointer;
        z-index: 9;
      }
      .view-box{
        position: relative;
        height:   810px;
        background: #Fff;
        .html{
          padding: 60px;
          .Right{
            background: #fe9;
          }
          ins{
            background: red;
          }
          del{
            display: block;
            background: #fd8;
            text-decoration-line: blink;
          }
          img{
            max-width: 100%;
          }
          html, address,blockquote,body, dd, div,dl, dt, fieldset, form,frame, frameset,h1, h2, h3, h4,h5, h6, noframes,ol, p, ul, center,dir, hr, menu, pre   { display: block; unicode-bidi: embed }li              { display: list-item }head            { display: none }table           { display: table }tr              { display: table-row }thead           { display: table-header-group }tbody           { display: table-row-group }tfoot           { display: table-footer-group }col             { display: table-column }colgroup        { display: table-column-group }td, th          { display: table-cell }caption         { display: table-caption }th              { font-weight: bolder; text-align: center }caption         { text-align: center }body            { margin: 8px }h1              { font-size: 2em; margin: .67em 0 }h2              { font-size: 1.5em; margin: .75em 0 }h3              { font-size: 1.17em; margin: .83em 0 }h4, p,blockquote, ul,fieldset, form,ol, dl, dir,menu            { margin: 1.12em 0 }h5              { font-size: .83em; margin: 1.5em 0 }h6              { font-size: .75em; margin: 1.67em 0 }h1, h2, h3, h4,h5, h6, b,strong          { font-weight: bolder }blockquote      { margin-left: 40px; margin-right: 40px }i, cite, em,var, address    { font-style: italic }pre, tt, code,kbd, samp       { font-family: monospace }pre             { white-space: pre }button, textarea,input, select   { display: inline-block }big             { font-size: 1.17em }small, sub, sup { font-size: .83em }sub             { vertical-align: sub }sup             { vertical-align: super }table           { border-spacing: 2px; }thead, tbody,tfoot           { vertical-align: middle }td, th, tr      { vertical-align: inherit }s, strike,hr              { border: 1px inset }ol, ul, dir,menu, dd        { margin-left: 40px }ol              { list-style-type: decimal }ol ul, ul ol,ul ul, ol ol    { margin-top: 0; margin-bottom: 0 }u, ins          { text-decoration: underline }br:before       { content: "\A"; white-space: pre-line }center          { text-align: center }:link, :visited { text-decoration: underline }:focus          { outline: thin dotted invert }/* Begin bidirectionality settings (do not change) */BDO[DIR="ltr"]  { direction: ltr; unicode-bidi: bidi-override }BDO[DIR="rtl"]  { direction: rtl; unicode-bidi: bidi-override }*[DIR="ltr"]    { direction: ltr; unicode-bidi: embed }*[DIR="rtl"]    { direction: rtl; unicode-bidi: embed }@media print {
          h1            { page-break-before: always }

          h1, h2, h3,

          h4, h5, h6    { page-break-after: avoid }

          ul, ol, dl    { page-break-before: avoid }}
          pre[class*="language-"]{
            border:0;
            box-shadow:none;
          }
        }
      }
      .content-left{
        flex: 1;
        border: 1px solid #DFDFDF;
        border-radius: 5px;
        overflow: hidden;
        .remark-scroll{
          .remark-list{
            padding-bottom: 0;
            list-style: none;
            .remark-item{
              margin: 20px 20px 20px;
              padding:18px 21px 14px 19px;
              background: #F8F8F8;
              border-radius: 5px;
              .list-title{
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                margin-bottom: 10px;
                font-size: 14px;
                .b{
                  color: #27252B;
                }
                .date{
                  color: #666;
                }
              }
              .list-content{
                // display: flex;
                white-space:normal;
                word-break:keep-all;
                word-wrap: break-word;
                line-height: 26px;
                color: #27252B;
                font-size: 14px;
              }
              .list-record{
                display: flex;
                margin-top: 10px;
                color: #666;
                line-height: 20px;
                font-size: 14px;
                .b{
                  margin-right: 20px;
                }
              }
            }
          }
        }
      }
      .content-right{
        margin-left: 20px;
        flex: 1;
        border: 1px solid #DFDFDF;
        border-radius: 5px;
        overflow: hidden;
        .audit-box{
          padding: 20px;
          .form-box{
            height: 316px;
            padding: 18px  18px 18px 18px;
            background: #F8F8F8;
            border-radius: 5px;
            .form-lable{
              font-size: 14px;
              color: #28262C;
              line-height: 40px;
              font-weight: bold;
            } 
            .audit-type{
              display: inline-block;
              margin-left: 13px;
              .radio{
                margin-right: 58px ;
              }
            }
            .form-msg{
              height: 110px;
              line-height: 110px;
              text-align: center;
              font-weight: bold;
              font-size: 14px;
              color: #28262C;
              text-align: center;
            }
            .date-box{
              height: 110px;
              text-align: left;
            }
          }
        }
      }
    }
  }
</style>